module.exports = __webpack_public_path__ + "img/purchase.bc72a938.svg";